"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeightFieldView = exports.Styles = exports.CSS = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const IkeModel = tslib_1.__importStar(require("@ikegps/core-shared"));
const core_shared_1 = require("@ikegps/core-shared");
const field_action_button_1 = require("../../../components/button/field.action.button");
const distance_input_1 = require("../../../components/input/distance.input");
const distance_input_state_1 = require("../../../components/input/distance.input.state");
const distance_input_style_1 = require("../../../components/input/distance.input.style");
const notification_service_1 = require("../../../components/notification.toast/notification.service");
const theme_1 = require("../../../components/theme");
const i18n_1 = require("../../../i18n");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const page_state_1 = require("../../../state/page.state");
const capture_thumbnail_1 = require("../../capture.thumbnail/capture.thumbnail");
exports.CSS = {
    container: 'c-PMLink',
    inputs: 'c-PMLink--inputs',
    isHovered: 'c-PMLink--hovered',
    isLinked: 'c-PMLink--linked',
    height: 'c-PMLink__Height',
};
exports.Styles = {
    [exports.CSS.container]: {
        display: 'flex',
        'justify-content': 'space-between',
    },
    [exports.CSS.inputs]: {
        flex: 1,
        display: 'flex',
        'justify-content': 'space-between',
        [`& .${distance_input_style_1.CSS.container}`]: {
            width: '100%',
        },
    },
    [exports.CSS.isHovered]: {
        'font-weight': 'bold',
    },
    [exports.CSS.isLinked]: {
        cursor: 'pointer',
    },
    [exports.CSS.height]: {
        width: '100%',
    },
};
(0, theme_1.addStyles)(exports.Styles);
function getValue(field, inputState) {
    if (field == null) {
        return 0;
    }
    const unit = services_1.Services.UserSettings.units;
    if (unit === core_shared_1.IkeUnit.METER) {
        const meters = inputState.meters.value || 0;
        return meters;
    }
    else {
        const inches = core_shared_1.IkeUnit.joinFeetInch(inputState.feet.value || 0, inputState.inch.value || 0);
        const meters = core_shared_1.IkeUnit.convert(inches, core_shared_1.IkeUnit.METER, core_shared_1.IkeUnit.INCH);
        return meters;
    }
}
function selectDrawable(draw, drawableId) {
    draw.state.setSelected(drawableId, null);
    return false;
}
function hoverDrawable(captureId, drawableId, hovered) {
    const draw = page_state_1.CurrentState.CollectionEdit.getIkeDraw(captureId);
    if (draw == null) {
        return;
    }
    if (hovered) {
        draw.state.setHovered(drawableId);
    }
    else if (draw.state.hoverId === drawableId) {
        draw.state.setHovered(null);
    }
}
exports.HeightFieldView = {
    viewInline(field) {
        return core_shared_1.IkeUnit.display(field.value, services_1.Services.UserSettings.units);
    },
    hasDetail(field) {
        return (field.provider === IkeModel.CollectionModelFieldHeight.PROVIDER_SPAN_HEIGHT && field.getCaptures().length > 0);
    },
    viewDetail(field) {
        if (!exports.HeightFieldView.hasDetail(field)) {
            return null;
        }
        const capture = field.getCaptures()[0];
        const title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
        return capture_thumbnail_1.CaptureThumbnail.view(field.collection, capture, { crosshair: true, title });
    },
    viewEdit(field, ctrl) {
        const currentDraw = page_state_1.CurrentState.CollectionEdit.currentDraw;
        const canLinkTo = currentDraw != null && currentDraw.drawState.hasUserMeasurements();
        if (field.hasValue()) {
            let className = exports.CSS.container;
            const heightInline = exports.HeightFieldView.viewInline(field, ctrl);
            if ((field.isPhotoMeasure() || field.isPhotoMeasureManual()) && currentDraw != null) {
                const stateValue = field.stateValue;
                const drawableId = field.stateValue.drawable;
                // If the current field is hovered
                if (currentDraw.state.hoverId === drawableId) {
                    className = className + ' ' + exports.CSS.isHovered;
                }
                // If the current field is part of the currentDrawable allow it to select the drawable
                let onclick = null;
                if (stateValue.captureId === currentDraw.capture.objectId) {
                    className = className + ' ' + exports.CSS.isLinked;
                    onclick = () => selectDrawable(currentDraw, drawableId);
                }
                // Set the hoverId for the drawable
                const onmouseover = () => hoverDrawable(stateValue.captureId, drawableId, true);
                const onmouseout = () => hoverDrawable(stateValue.captureId, drawableId, false);
                if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
                    let inputState = ctrl.changeState.getState(field.id);
                    if (inputState == null) {
                        inputState = new distance_input_state_1.DistanceInputState(field.schema.displayName);
                        inputState.onValue(() => {
                            if (!distance_input_state_1.DistanceInputState.equal(field.value, inputState.value)) {
                                field.Mutator.manualFromInput(getValue(field, inputState));
                            }
                        });
                        inputState.meters.onValue(() => {
                            inputState.updateMetric();
                            if (!distance_input_state_1.DistanceInputState.equal(field.value, inputState.value) && inputState.meters.value != null) {
                                field.Mutator.manualFromInput(getValue(field, inputState));
                            }
                        });
                        inputState.feet.onValue(() => {
                            inputState.updateImperial();
                            if (!distance_input_state_1.DistanceInputState.equal(field.value, inputState.value) && inputState.feet.value != null) {
                                field.Mutator.manualFromInput(getValue(field, inputState));
                            }
                        });
                        inputState.inch.onValue(() => {
                            inputState.updateImperial();
                            if (!distance_input_state_1.DistanceInputState.equal(field.value, inputState.value) && inputState.inch.value != null) {
                                field.Mutator.manualFromInput(getValue(field, inputState));
                            }
                        });
                        ctrl.changeState.addState(field.id, inputState);
                        const val = field.value;
                        if (val != null) {
                            inputState.setValue(val);
                        }
                    }
                    //if one of the input state has focus, it means that we are currently manually updating the value
                    //In this case, we do not want to overwrite it with the value calculated from the current drawable position
                    //otherwise, we update the inputState with the value calculated from the drawable
                    if (!(inputState.focused || inputState.meters.focused || inputState.feet.focused || inputState.inch.focused)) {
                        const val = field.value;
                        if (val != null) {
                            inputState.setValue(val);
                        }
                    }
                    return (0, mithril_1.m)('div', { className: exports.CSS.inputs, onmouseover, onmouseout, onclick }, [
                        distance_input_1.DistanceInput.view(inputState, services_1.Services.UserSettings.units),
                    ]);
                }
                else {
                    return (0, mithril_1.m)('div', { className, onmouseover, onmouseout }, [
                        (0, mithril_1.m)('span', { className: exports.CSS.height, onclick }, heightInline),
                    ]);
                }
            }
            return (0, mithril_1.m)('div', { className }, heightInline);
        }
        if (!canLinkTo) {
            return this.viewInline(field, ctrl);
        }
        const linkFieldIds = currentDraw.state.linkFieldIds;
        if (linkFieldIds.indexOf(field.id) !== -1) {
            return field_action_button_1.FieldActionButton.viewLinkHeight({
                linking: true,
                onclick: () => {
                    currentDraw.state.setTool(null);
                    currentDraw.state.setSelected(field.id, null);
                },
            });
        }
        // Some other field is being linked to
        if (linkFieldIds.length > 0) {
            return this.viewInline(field, ctrl);
        }
        // No fields are being linked show the link start behavior
        return field_action_button_1.FieldActionButton.viewLinkHeight({
            joinable: ctrl.getJoin(field) != null,
            onclick: () => {
                page_state_1.CurrentState.cancelInteractions();
                const oppositeJoin = ctrl.getOppositeJoin(field);
                if (oppositeJoin != null) {
                    currentDraw.state.setLinkFields([field.id, oppositeJoin.field.id]);
                    notification_service_1.NotificationService.info({ key: i18n_1.T.PHOTOMEASURE_JOIN_START, attrs: oppositeJoin.getTitle() });
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'measurement:join', ctrl.collection.revision, 1);
                }
                else {
                    services_1.Services.Analytics.trackTiming(core_api_1.TimingEventType.HOA, core_api_1.TimingEventAction.ENTER, currentDraw.collection.id, new Date());
                    currentDraw.state.setLinkFields([field.id]);
                }
            },
        });
    },
};
//# sourceMappingURL=height.field.view.js.map